"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_ENV = 'development';

function config(configDefitions, overriddenEnv) {
  if (!configDefitions) throw new TypeError('Missing configuration argument');
  var actualEnv = overriddenEnv || getNodeEnv() || DEFAULT_ENV;

  if (!configDefitions.hasOwnProperty(actualEnv)) {
    throw new ConfigError(actualEnv);
  }

  var envConfig = configDefitions[actualEnv];

  if (!configDefitions.hasOwnProperty('default')) {
    return envConfig;
  }

  var defaultConfig = configDefitions.default;
  return Object.assign({}, defaultConfig, envConfig);
}

exports.default = config;

function getNodeEnv() {
  if (typeof process === 'undefined') return undefined;
  if (!process.env || !process.env.NODE_ENV) return undefined;
  return process.env.NODE_ENV;
}

var ConfigError =
/** @class */
function (_super) {
  __extends(ConfigError, _super);

  function ConfigError(envName) {
    var _this = _super.call(this, "No such configuration as " + envName) || this;

    _this.name = 'ConfigError';
    return _this;
  }

  return ConfigError;
}(Error);

exports.ConfigError = ConfigError;